import { Link } from 'gatsby'
import React from 'react'
import PropTypes from 'prop-types'
import { createNavigationUrl } from '../../helpers/createNavigationUrl'
import Icon from '../Icon/Icon'
import './_links.scss'

export const InternalLink = ({ data, matchPages, icon, scroll }) => {
  switch (data.type) {
    case 'link':
      return (
        <Link
          to={createNavigationUrl(matchPages?.nodes, data)}
          className={`d-flex flex-row text-uppercase nav-link link-style ${
            scroll < 577 ? 'link-style-white' : 'link-style-dark'
          }`}
        >
          {icon && <Icon {...icon} hasMargin={true}/>}
          {data.name}
        </Link>
      )
    case 'button':
      return (
        <Link
          to={createNavigationUrl(matchPages?.nodes, data)}
          className={`btn btn-md rounded-pill d-flex flex-row px-3 text-uppercase btn-style`}
          target='_blank'
          rel='noreferrer'
        >
          {icon && <Icon {...icon} hasMargin={true}/>}
          {data.name}
        </Link>
      )
    case 'buttonWhite':
      return (
        <Link
          to={createNavigationUrl(matchPages?.nodes, data)}
          className={`btn btn-md rounded-pill d-flex flex-row px-3 text-uppercase btn-white-style ${
            scroll < 577 ? 'btn-white-style-white' : 'btn-white-style-dark'
          }`}
          target='_blank'
          rel='noreferrer'
        >
          {icon && <Icon {...icon} hasMargin={true}/>}
          {data.name}
        </Link>
      )

    default:
      return (        
        <Link
          to={createNavigationUrl(matchPages?.nodes, data)}
          className={`d-flex flex-row text-uppercase nav-link link-style ${
            scroll < 577 ? 'link-style-white' : 'link-style-dark'
          }`}
        >
          {icon && <Icon {...icon} hasMargin={true}/>}
          {data.name}
        </Link>
      )
  }
}

InternalLink.propTypes = {
  data: PropTypes.object.isRequired,
  matchPages: PropTypes.object.isRequired,
  icon: PropTypes.object,
  scroll: PropTypes.number
}
